import { TEMPLATE_BUILDING_BLOCKS_FILTER_FUNCTION_VALUE } from "pages/Templates/constants";

export const COMMUNITY_PORTAL = {
  BASE_URL: "https://community.appsmith.com",
};

export const CANVAS_STARTER_TEMPLATES_SEE_MORE_BUILDING_BLOCKS_PRE_FILTER = {
  functions: [TEMPLATE_BUILDING_BLOCKS_FILTER_FUNCTION_VALUE],
};
